import React from "react";
import { Link } from "react-router-dom";
import "./ContactUs.css";

const HiringProcess = () => {
  return (
    <div id="contact" className="contact-container">
      <div className="contact-container">
        <h1 className="main-title">Transforming Idea into Reality!</h1>

        <div className="contact-list">
          <div className="contact-item">
            <div className="icon-box">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                viewBox="0 0 24 24"
              >
                <path
                  fill="#d67a3a"
                  d="M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2zm-2 0l-8 5l-8-5zm0 12H4V8l8 5l8-5z"
                />
              </svg>
            </div>
            <div className="content">
              <h3>Email Us</h3>
              <p>information@nimble-byte.com</p>
            </div>
          </div>

          <div className="contact-item">
            <div className="icon-box">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                viewBox="0 0 24 24"
              >
                <path
                  fill="#d67a3a"
                  d="M18.93 20q-2.528 0-5.184-1.266t-4.944-3.555q-2.27-2.288-3.536-4.935T4 5.07q0-.45.3-.76T5.05 4h2.473q.408 0 .712.257t.411.659L9.142 7.3q.07.42-.025.733t-.333.513L6.59 10.592q.616 1.117 1.361 2.076t1.59 1.817q.87.87 1.874 1.62q1.004.749 2.204 1.414l2.139-2.177q.244-.263.549-.347q.304-.083.674-.033l2.103.43q.408.1.662.411t.254.712v2.435q0 .45-.31.75t-.76.3"
                />
              </svg>
            </div>
            <div className="content">
              <h3>Call Us</h3>
              <p>+234-906 928 9187</p>
            </div>
          </div>

          <div className="contact-item">
            <div className="icon-box">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                viewBox="0 0 24 24"
              >
                <g fill="none">
                  <path
                    d="M12 2a8 8 0 0 1 8 8c0 6.5-8 12-8 12s-8-5.5-8-12a8 8 0 0 1 8-8m0 5a3 3 0 1 0 0 6a3 3 0 0 0 0-6"
                    clip-rule="evenodd"
                  />
                  <path
                    stroke="#d67a3a"
                    stroke-width="2"
                    d="M20 10c0 6.5-8 12-8 12s-8-5.5-8-12a8 8 0 1 1 16 0Z"
                  />
                  <path
                    stroke="#d67a3a"
                    stroke-width="2"
                    d="M15 10a3 3 0 1 1-6 0a3 3 0 0 1 6 0Z"
                  />
                </g>
              </svg>
            </div>
            <div className="content">
              <h3>Visit Us</h3>
              <p>
                No 13, Maitama Sule Street,
                <br />
                Off Raymond Njoku S/W, <br />
                Ikoyi, Lagos State, Nigeria.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default HiringProcess;
